import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WidgetCumulativeStatusService } from "./service/widget-overall-cumulative-status.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
import { GenericUtils } from "../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

addMore(Highcharts);

@Component({
  selector: "widget-overall-cumulative-status",
  templateUrl: "./widget-overall-cumulative-status.component.html",
  styleUrls: ["./widget-overall-cumulative-status.component.scss"],
  providers: [WidgetCumulativeStatusService]
})
export class WidgetOverallCumulativeStatusComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 20;

  highcharts: typeof Highcharts = Highcharts;
  loadingChart = true;
  chartOptions = HSET.chartData;
  errorMessage = "";
  mockChart = null;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetCumulativeStatusService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute,
    private utils: GenericUtils
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    
  }

  ngOnInit() {
    this.translateService
      .get("WAREHOUSE.WAREHOUSE_SLA_TREND")
      .subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
    });
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS));
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
        const fcCode = this.FILTERS['origin_fc_code'];
        if (fcCode) {
          this.FILTERS['origin_fc_code'] = fcCode.split(' / ')[1] ? fcCode.split(' / ')[1] : fcCode;

        }       
        this.FILTERS = this.utils.cleanNullKeys(this.FILTERS);
        this.getSLAtrendData();
      } else {
        this.FILTERS = JSON.parse(JSON.stringify(intiFilter));
        this.getSLAtrendData();
      }
    })
  }

  getSLAtrendData() {
    const params = {};
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.dataService.getSLAtrendData(this.OPTIONS.api, this.FILTERS).pipe(takeUntil(this.unsubscribe)).subscribe(
      chart => {
        if (chart.data && Object.keys(chart.data).length) {
          this.loadingChart = false;
          this.chartOptions = this.dataService.createChart(chart.data, this.OPTIONS);
        } else {
          this.loadingChart = true;
          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.loadingChart = true;
        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
